import { Button } from "@/components/ui/button";
import config from "@/config";
import { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

export default function LoginSSOPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    // const sso_url = `${config.BACKEND_URL[import.meta.env.VITE_RELEASE_STAGE as keyof typeof config.BACKEND_URL]}/auth/login/sso/`;
    const sso_url = `${config.BACKEND_URL[import.meta.env.VITE_RELEASE_STAGE as keyof typeof config.BACKEND_URL]}/auth/oidc/login/`;

    useEffect(() => {
        localStorage.setItem("redirect", from);
        window.location.replace(sso_url);
    }, [from, navigate, sso_url]);

    return (
        <>
            <div className="flex">
                <div className="hidden h-screen w-1/2 bg-sky-200 lg:block"></div>
                <div className="flex h-screen w-full min-w-[500px] items-center justify-center bg-background lg:w-1/2">
                    <div className="w-full max-w-[350px] p-4 text-center">
                        <h2 className="mb-4 text-xl font-bold">Redirection en cours...</h2>
                        <Button type="button" variant="outline" asChild>
                            <NavLink to={sso_url}>Cliquez ici</NavLink>
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
}
